var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "person-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "person-Rectangle_957",
    "data-name": "Rectangle 957",
    width: 35,
    height: 35,
    transform: "translate(-0.432 -0.432)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person-Group_1331",
    "data-name": "Group 1331",
    transform: "translate(0.432 0.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-Group_1330",
    "data-name": "Group 1330",
    transform: "translate(0 -0.076)",
    clipPath: "url(person-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person-Path_219",
    "data-name": "Path 219",
    d: "M26.416,27.7a14.415,14.415,0,0,1-9.372,3.551A14.415,14.415,0,0,1,7.672,27.7a1.379,1.379,0,0,1-.14-1.99,12.73,12.73,0,0,1,5.962-3.831,7.839,7.839,0,0,0,7.1,0,12.128,12.128,0,0,1,5.962,3.831,1.278,1.278,0,0,1-.14,1.99M17.044,5.681c3.121,0,5.681,3.121,5.681,7.1s-2.56,7.1-5.681,7.1-5.681-3.121-5.681-7.1,2.56-7.1,5.681-7.1m0-5.681A17.044,17.044,0,1,0,34.088,17.044,17.1,17.1,0,0,0,17.044,0",
    transform: "translate(0 0.049)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.71c62d896ad9e59ddac24551a9fe6f25.svg";
export { ForwardRef as ReactComponent };